export default class PNRG {
  constructor(seed) {
    this.seed = seed % 2147483647;
    if (this.seed <= 0) this.seed += 2147483646;
  }

  get random() {
    this.seed = (this.seed * 16807) % 2147483647;
    return this.seed;
  }

  get float() {
    return (this.random - 1) / 2147483646;
  }

  get int() {
    return this.max();
  }

  max(max = 100) {
    return Math.floor(this.float * Math.floor(max));
  }

  next(max = 100) {
    const newRandom = this.max(max);
    if (newRandom === this.lastRandom) return this.next(max);
    this.lastRandom = newRandom;
    return newRandom;
  }
}
